import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  parts: [],
};

const getters = {
  getParts: (state) => state.parts,
};

const actions = {
  async fetchParts({ commit }) {
    try {
      const resp = await api.get("/parts");
      if (resp.status == 200) {
        const parts = resp.data.data;
        //console.log("parts", parts);
        commit("setParts", parts);
      }
    } catch (error) {
      //console.log("error", error);
      return false;
    }
  },
  async updateParts({ commit }, part) {
    try {
      const id = part.id;
      part._method = "patch";
      console.log("part", part);
      const resp = await api.post(`/parts/${id}`, part);
      if (resp.status == 200) {
        const part = resp.data.data;

        commit("updateParts", part);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setParts(state, parts) {
    state.parts = parts;
  },
  updateParts(state, part) {
    const id = part.id;
    const index = state.parts.findIndex((part) => part.id == id);
    if (index !== -1) {
      state.parts[index] = part;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
